import React, { StrictMode } from "react";
import { useDispatch } from "react-redux";
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import Cookies from "js-cookie";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

import store from "../store/index";
import '../i18n';
import { getCurrentRoute } from "../utils/index";
import useDisableBrowserBack from "./hooks/useDisableBrowserBack";

//redux dispachers
import { getGroupsByGame, getGroupsStatus, getGroupsStatusTest } from './dashboard/dashboardSlice'; 
import { getGroupByPlayer, getGameStatus, getAvatar } from './game/gameSlice';

//teacher flow components
import NewGame from "./teacher/newGame";
import Monitor from "./teacher/monitor";

// digiboard components
import Dashboard from "./dashboard";
import OpenDashboard from "./dashboard/openDashboard";
import FindGroupDashboard from "./dashboard/findGroupDashboard";
import ScoreboardDashboard from "./dashboard/scoreboardDashboard";


//student game components
import Start from "./game/start";
import Intro from "./game/intro";
import Onboard from "./game/onboard";
import Register from "./game/register";
import AvatarDesigner from "./game/avatarDesigner/avatarDesigner";
import FindGroup from "./game/findGroup";
import Roles from "./game/roles";
import Outro from "./game/outro";
import RotateMessage from "./game/rotateMessage";
import GameOverview from "./game/gameOverview/gameOverview";
import QuestionOverview from "./game/questionContainer/questionOverview";
import TimesUp from "./game/finish/timesUp";
import MissionsSummary from "./game/finish/missionsSummary";
import GroupsSummary from "./game/finish/groupsSummary";
import RewardsSummary from "./game/finish/rewardsSummary";
import EndScreen from "./game/finish/endScreen";

//styles
import '../../sass/game/app.scss';
import Demo from "./game/demos/demo";
import DemoWithIntro from "./game/demos/demoWithOnboarding";
import DemoAvatar from "./game/demos/demoAvatar";


//detecting mobiles
var userAgent = navigator.userAgent || "";
var isMobile = /[^a-zA-Z0-9](?:(?:IE)?Mobi(?:le)?)[^a-zA-Z0-9]/gi.test(userAgent);
if(isMobile)
{
    document.body.classList.add("mobile");
}

let dispatch;

window.Pusher = Pusher;
const options = {
    broadcaster: "pusher",
    key: "medievalme",
    wsHost: window.location.hostname,
    wsPort: process.env.MIX_PUSHER_WS_PORT,
    wssPort: process.env.MIX_PUSHER_WSS_PORT,
    forceTLS: false,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
};

window.Echo = new Echo(options);

const retryConnection = () => { 
    console.log('error connecting');
    const currentRoute = getCurrentRoute();
    if(currentRoute === "GAME_FIND_GROUPS" || currentRoute === "GAME_ASSIGN_ROLES"){
        console.log('inside error');
        const cookiePlayerId = Cookies.get("player_id");
        dispatch(getGroupByPlayer(cookiePlayerId));
    }
}

window.Echo.connector.pusher.connection.bind( 'error', retryConnection);
  
const cookieGameId = Cookies.get("game_id");
if(cookieGameId && cookieGameId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i)){
    window.Echo.channel("game_" + cookieGameId).listen("GameEvent", (e) => {
        const currentRoute = getCurrentRoute();
        if (e.type === "USER_JOINED" || e.type === "USER_ROLE_CHANGED" || e.type === "USER_CREATED") {
            if(currentRoute === "GAME_FIND_GROUPS" || currentRoute === "GAME_ASSIGN_ROLES"){
                let cookiePlayerId = Cookies.get("player_id");
                let cookieGroupId = Cookies.get("group_id");
                const params = new URLSearchParams(window.location.search);
                if(params.get('demo') === 'true'){
                    cookiePlayerId = Cookies.get("player_id_" + params.get('player'));
                }
                
                if(e.data.group_id == cookieGroupId){
                    dispatch(getGroupByPlayer(cookiePlayerId));
                }
            }

            if(currentRoute === "DASHBOARD_FIND_GROUPS" || currentRoute === "DASHBOARD_ONBOARD"){
                dispatch(getGroupsByGame(cookieGameId));
            }
            
        } else if (e.type === "MISSION_UPDATED") {
            if(currentRoute === "QUESTION_OVERVIEW" || currentRoute === "GAME_OVERVIEW"){
                const cookieGroupId = Cookies.get("group_id");
                dispatch(getGameStatus(cookieGroupId));
            }if(currentRoute === "SCORE_BOARD"){
                const cookieGameId = Cookies.get('game_id');
                dispatch(getGroupsStatus(cookieGameId));
                //dispatch(getGroupsStatusTest(cookieGameId));
            }
        } else if (e.type === "AVATAR_UPDATED"){
            console.log(currentRoute)
            if(currentRoute === "AVATAR_DESIGNER"){
                console.log('avatar updated')
                const cookieGroupId = Cookies.get("group_id");
                dispatch(getAvatar(cookieGroupId));
            }
        }
    
    });
}

function Container() {
    dispatch = useDispatch();
    return (
            <BrowserRouter>
                <Routes>
                  <Route extact="true" path="app/teacher/" element={<Navigate to="/app/teacher/onboard/" />} />
                  <Route extact="true" path="app/" element={<Navigate to="/app/game/" />} />
                  <Route path="app/teacher/onboard/" element={<NewGame />} />
                  <Route path="app/teacher/monitor/:gameId" element={<Monitor /> }  />
                  <Route path="app/game/" element={<Start />} />
                  <Route path="app/game/intro/" element={<Intro screen={0} />} />
                  <Route path="app/game/intro/1" element={<Intro screen={0} />} />
                  <Route path="app/game/intro/2" element={<Intro screen={1} />} />
                  <Route path="app/game/onboard" element={<Onboard />} />
                  <Route path="app/game/register/:gameId" element={<Register />} />
                  <Route path="app/game/avatar/:gameId/:playerId" element={<AvatarDesigner />} />
                  <Route path="app/game/group/find/:gameId/:playerId" element={<FindGroup />} />
                  <Route path="app/game/roles/:gameId" element={<Roles />} />
                  <Route path="app/game/outro/" element={<Outro screen={0} />} />
                  <Route path="app/game/outro/1" element={<Outro screen={0} />} />
                  <Route path="app/game/outro/2" element={<Outro screen={1} />} />
                  <Route path="app/game/overview" element={<GameOverview />} />
                  <Route path="app/game/questions" element={<QuestionOverview />} />
                  <Route path="app/game/timesup" element={<TimesUp />} />
                  <Route path="app/game/missionsSummary" element={<MissionsSummary />} />
                  <Route path="app/game/groupsSummary" element={<GroupsSummary />} />
                  <Route path="app/game/rewardsSummary" element={<RewardsSummary />} />
                  <Route path="app/game/end" element={<EndScreen />} />
                  <Route path="app/digiboard" element={<OpenDashboard />} />
                  <Route path="app/digiboard/:gameId" element={<OpenDashboard />} />
                  <Route path="app/digiboard/onboard/:gameId" element={<Dashboard />} />
                  <Route path="app/digiboard/findGroups/:gameId" element={<FindGroupDashboard />} />
                  <Route path="app/digiboard/scoreBoard/:gameId" element={<ScoreboardDashboard />} />
                  <Route path="app/game/demo" element={<Demo />} />
                  <Route path="app/game/demo-intro" element={<DemoWithIntro />} />
                  <Route path="app/game/demo-avatar" element={<DemoAvatar />} />
                </Routes>
            </BrowserRouter>
    );
}

if (document.getElementById("app-container")) {
    const root = ReactDOMClient.createRoot(
        document.getElementById("app-container")
    );
    root.render(
        <StrictMode>
            <Provider store={store}>
                <Container />
                <RotateMessage />
            </Provider>
        </StrictMode>
    );
}
